import { PhoneCountryCodeType } from '@bus/models';
import { CorrespondenceMethodEnum } from '../../../types/forms';
import { ContactDetailsFormNewModel } from './formModel';

export const contactDetailsFormNewInitialValues: ContactDetailsFormNewModel = {
  title: undefined,
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  email: '',
  invoiceEmailAddress: '',
  countryCode: PhoneCountryCodeType.Ireland,
  mobileNumber: '',
  correspondenceMethod: CorrespondenceMethodEnum.email,
};
